export default "__VITE_ASSET__CXjn32o___"